import { FC } from 'react';
import { Box, Container, Theme, Typography } from '@material-ui/core';
import { createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      background: '#ffffff 0% 0% no-repeat padding-box',
      color: '#333333',
      maxWidth: '523px',
    },
    title: {
      fontSize: '32px',
      lineHeight: '48px',
      fontWeight: 'bold',
      textAlign: 'center',
      marginBottom: theme.spacing(2),
      [theme.breakpoints.down(768)]: {
        fontSize: '24px',
      },
      '& span': {
        display: 'block',
      },
    },
    subtitle: {
      fontSize: '14px',
      lineHeight: '21px',
      textAlign: 'center',
      marginBottom: theme.spacing(5),
    },
    img: {
      maxWidth: '459px',
      height: '100%',
      background: 'transparent',
      marginBottom: theme.spacing(5),
      '& img': {
        width: '100%',
      },
    },
    imgDiv: {
      position: 'relative',
      width: '100%',
      background: '#f2f3fB 0% 0% no-repeat padding-box',
      marginBottom: theme.spacing(5),
      '&:before': {
        content: '""',
        display: 'block',
        paddingTop: '55.5%',
      },
    },
    article: {
      wordWrap: 'break-word',
      fontSize: '14px',
      lineHeight: '21px',
      color: '#333333',
      ' & > *': {
        marginBottom: theme.spacing(5),
        '&:last-child': {
          marginBottom: 0,
        },
      },
      '& .MuiTypography-body1': {
        color: '#333333',
        fontSize: '14px',
        lineHeight: '21px',
        paddingTop: 0,
        paddingBottom: 0,
      },
      '& .MuiTypography-body2': {
        color: '#333333',
        fontSize: '14px',
        lineHeight: '21px',
      },
      '& .MuiList-root': {
        '& .MuiListItem-root': {
          width: 'initial',
          display: 'list-item',
          marginLeft: '1.5rem',
          paddingTop: 0,
          paddingBottom: 0,
          marginTop: theme.spacing(1),
          '&:first-child': {
            marginTop: 0,
          },
        },
      },
      '& .MuiList-padding': {
        paddingTop: 0,
        paddingBottom: 0,
      },
      '& ol.MuiList-root': {
        listStyle: 'decimal',
      },
      '& ul.MuiList-root': {
        listStyle: 'disc',
      },
    },
  }),
);

export interface DocumentIntroductionProps {
  title?: React.ReactNode;
  subtitle?: string;
  imgSrc?: string;
  imgAlt?: string;
  children?: React.ReactNode;
  className?: string;
}

export const DocumentIntroduction: FC<DocumentIntroductionProps> = ({
  title,
  subtitle,
  imgSrc,
  imgAlt,
  children,
  className,
}) => {
  const classes = useStyles();

  return (
    <Container disableGutters className={`${classes.root} ${className ?? ''}`}>
      <Typography component="h1" className={classes.title}>
        {title}
      </Typography>
      <Typography
        variant="subtitle1"
        component="p"
        className={classes.subtitle}
      >
        {subtitle}
      </Typography>
      {imgSrc ? (
        <Box className={classes.img}>
          <img src={imgSrc} alt={imgAlt} />
        </Box>
      ) : (
        <Box className={classes.imgDiv}></Box>
      )}
      <Box component="article" className={classes.article}>
        {children}
      </Box>
    </Container>
  );
};
